export default function getLang() {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const lang = urlParams?.get("language");
  const regex = new RegExp(/-|_/);
  if (lang && regex.test(lang)) {
    return lang.split(regex)[0];
  }
  return lang;
}
